import React from 'react';
import { TableHead, TableRow, TableCell } from '@mui/material';
import OverflowTooltip from './OverflowTooltip';
import { COLUMNS, cellStyle } from './UpdateStaffTableStyles';
import icUpdownArrow from 'Assets/img/ic_updown_arrow_12_000@2x.png';
import icUpArrow from 'Assets/img/ic_up_arrow_16_000@2x.png';
import IntlMessages from 'Util/IntlMessages';
import { useIntl } from 'react-intl';
import BasicCheckbox from 'Components/Toggle/BasicCheckbox';

const UpdateStaffTableHeader = ({ setSort, sort, hoveredColumn, setHoveredColumn, isAllSelected, onSelectAll, isSupervisor, originalStaffs, items }) => {
  const { formatMessage } = useIntl();

  const sortCellIcon = (type, isHovered) => {
    const isDesc = sort.startsWith('-');
    const isSelected = (isDesc ? sort.slice(1) : sort) === type;

    // 선택된 컬럼이면 icUpArrow 표시
    if (isSelected) {
      if (!isDesc) {
        return <img src={icUpArrow} alt='' style={{ width: 16, height: 16 }} />;
      }
      // -가 붙으면 icUpArrow 180도 회전
      return <img src={icUpArrow} alt='' style={{ width: 16, height: 16, transform: 'rotate(180deg)' }} />;
    }

    // 선택되지 않은 컬럼이면 hover 상태일 때만 icUpdownArrow 표시
    if (isHovered) {
      return <img src={icUpdownArrow} alt='' style={{ width: 12, height: 12 }} />;
    }

    return null;
  };

  const sortCell = (type, labelId, index) => {
    const isHovered = hoveredColumn === index + 1;
    const isDesc = sort.startsWith('-');
    const isSelected = (isDesc ? sort.slice(1) : sort) === type;

    return (
      <div
        className='cursor-pointer'
        style={{ ...cellStyle }}
        onClick={() => {
          setSort(prev => {
            // 현재 정렬이 같은 컬럼이면 토글, 다른 컬럼이면 새로 정렬 (오름차순부터)
            if (prev === type) return '-' + type;
            if (prev === '-' + type) return type;
            return type; // 새로 정렬할 때는 오름차순부터
          });
        }}
        onMouseEnter={() => setHoveredColumn(index + 1)}
        onMouseLeave={() => setHoveredColumn(null)}
      >
        <IntlMessages id={labelId} />
        <div style={{ position: 'absolute', right: '2px', bottom: '8px', opacity: isSelected || isHovered ? 1 : 0 }}>{sortCellIcon(type, isHovered)}</div>
      </div>
    );
  };

  const getColumnStyle = (column, index) => {
    const baseStyle = {
      background: hoveredColumn === index + 1 ? 'var(--Surface-Default-2-Hover, #F0F0F0) !important' : 'var(--Surface-Default-2-Rest, #F8F8F8) !important',
      borderBottom: '1px solid var(--Border-Default-1-Rest, #E4E4E4) !important',
      height: '36px !important',
      overflow: 'hidden !important',
    };

    // 체크박스 열인 경우
    if (column.key === 'select') {
      return {
        ...baseStyle,
        width: '40px !important',
        maxWidth: '40px !important',
        minWidth: '40px !important',
        padding: '0 !important',
        textAlign: 'center !important',
      };
    }

    if (column.width === 'flex') {
      return { ...baseStyle, flex: '1 1 0 !important' };
    }

    return {
      ...baseStyle,
      width: `${column.width} !important`,
      maxWidth: `${column.width} !important`,
      minWidth: `${column.width} !important`,
    };
  };

  return (
    <TableHead>
      <TableRow>
        {COLUMNS.map((column, index) => (
          <TableCell
            key={column.key}
            onMouseEnter={column.sortable ? () => setHoveredColumn(index + 1) : undefined}
            onMouseLeave={column.sortable ? () => setHoveredColumn(null) : undefined}
            sx={getColumnStyle(column, index)}
          >
            {column.key === 'select' ? (
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                <BasicCheckbox
                  isChecked={isAllSelected}
                  size='small'
                  onClick={() => {
                    // isSupervisor가 아닌 경우 기존 staffs를 제외하고 선택
                    if (!isSupervisor) {
                      const selectableItems = items.filter(item => !originalStaffs.some(original => original._id === item._id));
                      onSelectAll(!isAllSelected, selectableItems);
                    } else {
                      onSelectAll(!isAllSelected);
                    }
                  }}
                />
              </div>
            ) : column.sortable ? (
              sortCell(column.key, column.labelId, index)
            ) : (
              <OverflowTooltip title={formatMessage({ id: column.labelId })} placement='top'>
                <div className='cursor-default' style={{ ...cellStyle }}>
                  <IntlMessages id={column.labelId} />
                </div>
              </OverflowTooltip>
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default UpdateStaffTableHeader;
